import Pristine from 'pristinejs';
import AbandonmentTracking from '../modules/abandonment-tracking';
import updateDonationHeaderCTA from '../modules/donation-links';
import { loadTurnstile, removeTurnstile } from '../modules/turnstile';

document.addEventListener('alpine:init', () => {
  Alpine.data('donationsSA', (input, formFrequency, formNameGA, prefill) => {
    let form = null;
    let $form = null;
    let pristine = null;
    let _iframePing = 0;
    const isPuppyPals = formFrequency === 'puppy_pals';

    return {
      ...input,
      activeIndex: 0,
      errors: {},
      countryList: {
        AF: 'Afghanistan',
        AX: 'Aland Islands',
        AL: 'Albania',
        DZ: 'Algeria',
        AS: 'American Samoa',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarctica',
        AG: 'Antigua And Barbuda',
        AR: 'Argentina',
        AM: 'Armenia',
        AW: 'Aruba',
        AU: 'Australia',
        AT: 'Austria',
        AZ: 'Azerbaijan',
        BS: 'Bahamas',
        BH: 'Bahrain',
        BD: 'Bangladesh',
        BB: 'Barbados',
        BY: 'Belarus',
        BE: 'Belgium',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BT: 'Bhutan',
        BO: 'Bolivia',
        BA: 'Bosnia And Herzegovina',
        BW: 'Botswana',
        BV: 'Bouvet Island',
        BR: 'Brazil',
        IO: 'British Indian Ocean Territory',
        BN: 'Brunei Darussalam',
        BG: 'Bulgaria',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        KH: 'Cambodia',
        CM: 'Cameroon',
        CA: 'Canada',
        CV: 'Cape Verde',
        KY: 'Cayman Islands',
        CF: 'Central African Republic',
        TD: 'Chad',
        CL: 'Chile',
        CN: 'China',
        CX: 'Christmas Island',
        CC: 'Cocos (Keeling) Islands',
        CO: 'Colombia',
        KM: 'Comoros',
        CG: 'Congo',
        CD: 'Congo, Democratic Republic',
        CK: 'Cook Islands',
        CR: 'Costa Rica',
        CI: "Cote D'Ivoire",
        HR: 'Croatia',
        CU: 'Cuba',
        CY: 'Cyprus',
        CZ: 'Czech Republic',
        DK: 'Denmark',
        DJ: 'Djibouti',
        DM: 'Dominica',
        DO: 'Dominican Republic',
        EC: 'Ecuador',
        EG: 'Egypt',
        SV: 'El Salvador',
        GQ: 'Equatorial Guinea',
        ER: 'Eritrea',
        EE: 'Estonia',
        ET: 'Ethiopia',
        FK: 'Falkland Islands (Malvinas)',
        FO: 'Faroe Islands',
        FJ: 'Fiji',
        FI: 'Finland',
        FR: 'France',
        GF: 'French Guiana',
        PF: 'French Polynesia',
        TF: 'French Southern Territories',
        GA: 'Gabon',
        GM: 'Gambia',
        GE: 'Georgia',
        DE: 'Germany',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GR: 'Greece',
        GL: 'Greenland',
        GD: 'Grenada',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GG: 'Guernsey',
        GN: 'Guinea',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HT: 'Haiti',
        HM: 'Heard Island & Mcdonald Islands',
        VA: 'Holy See (Vatican City State)',
        HN: 'Honduras',
        HK: 'Hong Kong',
        HU: 'Hungary',
        IS: 'Iceland',
        IN: 'India',
        ID: 'Indonesia',
        IR: 'Iran, Islamic Republic Of',
        IQ: 'Iraq',
        IE: 'Ireland',
        IM: 'Isle Of Man',
        IL: 'Israel',
        IT: 'Italy',
        JM: 'Jamaica',
        JP: 'Japan',
        JE: 'Jersey',
        JO: 'Jordan',
        KZ: 'Kazakhstan',
        KE: 'Kenya',
        KI: 'Kiribati',
        KR: 'Korea',
        KW: 'Kuwait',
        KG: 'Kyrgyzstan',
        LA: "Lao People's Democratic Republic",
        LV: 'Latvia',
        LB: 'Lebanon',
        LS: 'Lesotho',
        LR: 'Liberia',
        LY: 'Libyan Arab Jamahiriya',
        LI: 'Liechtenstein',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        MO: 'Macao',
        MK: 'Macedonia',
        MG: 'Madagascar',
        MW: 'Malawi',
        MY: 'Malaysia',
        MV: 'Maldives',
        ML: 'Mali',
        MT: 'Malta',
        MH: 'Marshall Islands',
        MQ: 'Martinique',
        MR: 'Mauritania',
        MU: 'Mauritius',
        YT: 'Mayotte',
        MX: 'Mexico',
        FM: 'Micronesia, Federated States Of',
        MD: 'Moldova',
        MC: 'Monaco',
        MN: 'Mongolia',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MA: 'Morocco',
        MZ: 'Mozambique',
        MM: 'Myanmar',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NL: 'Netherlands',
        AN: 'Netherlands Antilles',
        NC: 'New Caledonia',
        NZ: 'New Zealand',
        NI: 'Nicaragua',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        NF: 'Norfolk Island',
        MP: 'Northern Mariana Islands',
        NO: 'Norway',
        OM: 'Oman',
        PK: 'Pakistan',
        PW: 'Palau',
        PS: 'Palestinian Territory, Occupied',
        PA: 'Panama',
        PG: 'Papua New Guinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PH: 'Philippines',
        PN: 'Pitcairn',
        PL: 'Poland',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        QA: 'Qatar',
        RE: 'Reunion',
        RO: 'Romania',
        RU: 'Russian Federation',
        RW: 'Rwanda',
        BL: 'Saint Barthelemy',
        SH: 'Saint Helena',
        KN: 'Saint Kitts And Nevis',
        LC: 'Saint Lucia',
        MF: 'Saint Martin',
        PM: 'Saint Pierre And Miquelon',
        VC: 'Saint Vincent And Grenadines',
        WS: 'Samoa',
        SM: 'San Marino',
        ST: 'Sao Tome And Principe',
        SA: 'Saudi Arabia',
        SN: 'Senegal',
        RS: 'Serbia',
        SC: 'Seychelles',
        SL: 'Sierra Leone',
        SG: 'Singapore',
        SK: 'Slovakia',
        SI: 'Slovenia',
        SB: 'Solomon Islands',
        SO: 'Somalia',
        ZA: 'South Africa',
        GS: 'South Georgia And Sandwich Isl.',
        ES: 'Spain',
        LK: 'Sri Lanka',
        SD: 'Sudan',
        SR: 'Suriname',
        SJ: 'Svalbard And Jan Mayen',
        SZ: 'Swaziland',
        SE: 'Sweden',
        CH: 'Switzerland',
        SY: 'Syrian Arab Republic',
        TW: 'Taiwan',
        TJ: 'Tajikistan',
        TZ: 'Tanzania',
        TH: 'Thailand',
        TL: 'Timor-Leste',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad And Tobago',
        TN: 'Tunisia',
        TR: 'Turkey',
        TM: 'Turkmenistan',
        TC: 'Turks And Caicos Islands',
        TV: 'Tuvalu',
        UG: 'Uganda',
        UA: 'Ukraine',
        AE: 'United Arab Emirates',
        GB: 'United Kingdom',
        US: 'United States',
        UM: 'United States Outlying Islands',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VU: 'Vanuatu',
        VE: 'Venezuela',
        VN: 'Viet Nam',
        VG: 'Virgin Islands, British',
        VI: 'Virgin Islands, U.S.',
        WF: 'Wallis And Futuna',
        EH: 'Western Sahara',
        YE: 'Yemen',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
      },
      stateList: {
        '': '',
        ACT: 'Australian Capital Territory',
        NSW: 'New South Wales',
        NT: 'Northern Territory',
        QLD: 'Queensland',
        SA: 'South Australia',
        TAS: 'Tasmania',
        VIC: 'Victoria',
        WA: 'Western Australia',
      },
      countrySelected: 'Australia',
      formName: formNameGA
        ? formNameGA
        : isPuppyPals
          ? 'GDSA-puppy-pals'
          : 'GDSA-donation-form',
      donationType:
        isPuppyPals || formFrequency === 'monthly' ? 'Monthly' : 'One-off',
      donationBy: 'individual',
      contactNumberType: 'mobile',
      manualEntry: true,
      ValidateStep2: {},
      ValidateStep3: {},
      donationAmount: null,
      donationAmountOther: null,
      dollarhandlesModelOnceOff: '',
      dollarhandlesModelMonthly: '',
      _errorMsg: '',
      _loading: false,

      init() {
        form = document.getElementById('donationsSA');
        $form = $(form);
        new AbandonmentTracking($form, 'progress-to-step-3-btn');

        pristine = new Pristine(form);

        _iframePing = 0;

        const alpineThis = this;

        const donateValueOther = document.querySelector('[name="other-amount"]');

        pristine.addValidator(
          donateValueOther,
          (val) => {
            return !(this.donationType !== 'One-off' && val < 10);
          },
          'The minimum amount for monthly donations is $10.',
          5,
          false,
        );

        updateDonationHeaderCTA($form, null, 'donate', false);

        $('[name="donate-value"]').on('change', function () {
          const other = $('[name="other-amount"]');

          alpineThis.donationAmount = $(this).val();

          alpineThis.donationAmountOther = null;

          other.val('');
        });

        $('[name="other-amount"]').on('input', function () {
          const donateValue = $('[name="donate-value"]').not('[value="other"]');

          donateValue.each(function () {
            $(this).prop('checked', false);
          });
        });


        this.setPreSelectedDonationAmount();

        this.handlePrefill(prefill);

        this.$watch('donationType', () => {
          this.$nextTick(() => {
            this.setPreSelectedDonationAmount();
          });
        });

        if ($('#contact-number-home').length > 0) {
          // Format the phone number as the user types it
          document
            .getElementById('contact-number-home')
            .addEventListener('keyup', function (evt) {
              var phoneNumber = document.getElementById('contact-number-home');
              phoneNumber.value = phoneFormat(phoneNumber.value);
            });

          document.getElementById('contact-number-home').value = phoneFormat(
            document.getElementById('contact-number-home').value,
          );

          document
            .getElementById('contact-number-work')
            .addEventListener('keyup', function (evt) {
              var workNumber = document.getElementById('contact-number-work');
              workNumber.value = phoneFormat(workNumber.value);
            });

          document.getElementById('contact-number-work').value = phoneFormat(
            document.getElementById('contact-number-work').value,
          );
        }

        // A function to format text to look like a phone number
        function phoneFormat(input) {
          input = input.replace(/\D/g, '');
          input = input.substring(0, 10);

          var size = input.length;
          if (size == 0) {
            input = input;
          } else if (size < 3) {
            input = '(' + input;
          } else {
            input = '(' + input.substring(0, 2) + ')' + input.substring(2, 10);
          }
          return input;
        }

        this.$watch('activeIndex', () => this.$store.stepperIndex.index = this.activeIndex);
      },
      setPreSelectedDonationAmount() {
        const newDonationType = $('[name="donate-frequency"]:checked').val();

        if (this.donationType === 'One-off' && newDonationType) {
          this.donationType = newDonationType;
        }

        const allHandles = $('[name="donate-value"]');
        const preSelectedHandle = $(
          `[data-js-conditional-value=${this.donationType}] [data-preselected]`,
        );
        const otherHandle = $(
          `[data-js-conditional-value=${this.donationType}] [value='other']`,
        );

        if (preSelectedHandle.length) {
          preSelectedHandle.prop('checked', true); // Required for case where One-off and Monthly values are preselected
          this.donationAmount = preSelectedHandle.val();
          this.donationAmountOther = null;
        } else if (this.donationAmountOther) {
          otherHandle.length > 0 && otherHandle.prop('checked', true);
          this.donationAmount = 'other';
        } else {
          allHandles.prop('checked', false);
          this.donationAmount = null;
          this.donationAmountOther = null;
        }
      },
      loading(isLoading = true) {
        //TODO add a spinner in the html that read this as well
        this._loading = isLoading;
      },
      error(errorMessage, errorObject = null) {
        this._errorMsg = errorMessage;
        console.error(errorObject); //TODO let's remove this and do it properly
      },
      handlePrefill(prefillData) {

        if (prefillData['donationType']) {
          this.donationType = prefillData.donationType.toLowerCase() === 'monthly' ? 'Monthly' : 'One-off';
        }

        Object.keys(prefillData).forEach((val) => {
          switch (val) {
            case 'donationAmountOther':
              this[val] = prefillData[val];
              break;
            case 'donationAmount':
              this['donationAmount'] = prefillData[val];
              const preSelectedHandle = $form.find(
                `[data-js-conditional-value=${this.donationType}] [value=${this['donationAmount']}]`,
              );
              preSelectedHandle.prop('checked', true);
              break;
            case 'title':
            case 'first-name':
            case 'last-name':
            case 'email':
              $form.find('#' + val).val(prefillData[val]);
              break;
            default:
              break;
          }
        });

        if (prefillData.step === '2') {
          this.next();
        }
      },
      _next() {
        this.activeIndex = Math.min(this.activeIndex + 1, input.steps.length - 1);

        this.scrollTop();
      },
      next() {
        if (this.validateForm() === false) {
          this.scrollTop();
          return;
        }

        this.setTrackingCookie();

        let newIndex = Math.min(this.activeIndex + 1, input.steps.length - 1);

        //TODO refactor this for the sake of quality
        if (newIndex === 2) {
          this.loading();
          this._addVarHiddenFields({
            final_amount: this._get_donation_amount(),
          });
          loadTurnstile(
            $form.find('[data-turnstile-1]')[0],
            (toke, turnstileID) => {
              this._createDonationOrder($form)
                .then((response) => {
                  this._addConsHiddenFields({
                    order_id: response.payload.order_id,
                  });
                  this.iframePing = 0;
                  let $iframeContainer = $form.find('[secureframe-iframe]');
                  $iframeContainer.html(response.payload.secureFrame);

                  if (response.payload.recurrence === 'oneoff') {
                    triggerSecureFrame(); //This is a global function
                  } else {
                    this.triggerRegularGivingPayment(
                      response.payload.monthlyUrl,
                      $iframeContainer,
                    );
                  }
                  this._next();
                })
                .catch((err) => {
                  if (err.status === 'error_fields') {
                    this.errors = err.payload; //Payload is a list of fields with errors
                  } else {
                    this.error(
                      'Something went wrong in the process, please check your inputs and try again',
                      err,
                    ); //TODO proper error handling, usually payload has error messages
                  }
                })
                .finally(() => {
                  removeTurnstile(turnstileID);
                  this.loading(false);
                });
            },
            'donate-sa-1',
            false,
          );
        } else {
          this._next();
        }
      },
      setTrackingCookie() {
        this.setCookie(
          this.formName,
          this._get_donation_amount(),
          this.donationType,
        );
      },
      setCookie(form, amount, frequency) {
        // Only set cookie if all values are present
        if (form && amount && frequency) {
          document.cookie = `campaign=${form};path=/`;
          document.cookie = `campaign-amount=${amount};path=/`;
          document.cookie = `campaign-frequency=${frequency};path=/`;
          document.cookie = `campaign-source=${window.location.href};path=/`;
        }
      },
      prev() {
        _iframePing = 0;
        // if (this.validateForm() === true) {
        this.activeIndex = Math.max(this.activeIndex - 1, 0);

        this.scrollTop();
        // }
      },
      scrollTop() {
        $('html, body').animate(
          {
            scrollTop:
              $('#formStepper').offset().top - $('#header').outerHeight(),
          },
          150,
        );
      },
      submit() {
        //this.validateForm();
      },
      manualAddressEntry() {
        this.manualEntry = true;
      },
      validateForm() {
        const errors = {};

        // Reset errors initially.
        this.errors = errors;

        // Grab all visible elements on the current step.
        const $currentStepElements = $(
          'input:not(:hidden), select:not(:hidden), texarea:not(:hidden)',
          '.donate-form__step.is-active',
        );

        let valid = pristine.validate($currentStepElements);

        // Go through each of the elements and find out if they have errors.
        $currentStepElements.each((i, el) => {
          const individualErrors = pristine.getErrors(el);

          if (individualErrors && individualErrors.length) {
            errors[el.getAttribute('name')] = individualErrors[0];
          }
        });

        // Set new errors.
        this.errors = errors;

        return valid;
      },
      _createDonationOrder(_$form) {
        return new Promise(function (resolve, reject) {
          const ajaxData = _$form.serializeArray();

          ajaxData.push({ name: 'action', value: 'create_donation_order' });

          $.post(guidedogsGlobals.ajaxurl, ajaxData, function (response) {
            if (response && response.status === 'OK') {
              resolve(response);
            } else {
              reject(response);
            }
          }).fail(reject);
        });
      },
      _addConsHiddenFields(objFields, _$form = false) {
        if (!_$form) _$form = $form;
        if (_$form.find('.consHiddenFields').length <= 0)
          _$form.prepend('<div class="consHiddenFields"></div>');

        const $hiddenContainer = _$form.find('.consHiddenFields');

        let $field;
        Object.keys(objFields).forEach((key) => {
          $field = $hiddenContainer.find('[name="' + key + '"]');
          if ($field.length > 0) {
            $field.val(objFields[key]);
          } else {
            $hiddenContainer.append(
              '<input type="hidden" name="' +
              key +
              '" value="' +
              objFields[key] +
              '">',
            );
          }
        });
      },
      _addVarHiddenFields(objFields, _$form = false) {
        if (!_$form) _$form = $form;
        if (_$form.find('.varHiddenFields').length <= 0)
          _$form.prepend('<div class="varHiddenFields"></div>');

        const $hiddenContainer = _$form.find('.varHiddenFields');

        $hiddenContainer.html('');

        Object.keys(objFields).forEach((key) => {
          $hiddenContainer.append(
            '<input type="hidden" name="' +
            key +
            '" value="' +
            objFields[key] +
            '">',
          );
        });
      },
      _get_donation_amount() {
        let amount = this.donationAmount;

        if (
          !isNaN(this.donationAmountOther) &&
          parseInt(this.donationAmountOther, 10) > 0
        ) {
          amount = this.donationAmountOther;
        }

        amount = parseFloat(amount);

        if (isNaN(amount)) {
          amount = 0;
        }

        return amount;
      },
      triggerRegularGivingPayment($url, $iframeContainer) {
        const iform = document.createElement('iframe');
        iform.setAttribute('src', $url);
        iform.className = 'iframe-monthly';

        $(iform).on(
          'load',
          function () {
            _iframePing++;
            if (_iframePing >= 2) {
              _iframePing = 0;

              this.loading();

              this._promiseSubmitPayment($form)
                .then((response) => {
                  var thankYouPage;

                  if (response.payload.recurrence === 'monthly') {
                    thankYouPage = '/thank-you-monthly/';
                  } else {
                    thankYouPage = '/thank-you-one-off/';
                  }

                  window.top.location = thankYouPage;
                })
                .catch((err) => {
                  this.loading(false);
                  if (err.status === 'error_fields') {
                    this.errors = err.payload; //Payload is a list of fields with errors
                  } else {
                    this.error('Something went wrong with the payment', err); //TODO proper error handling, usually payload has error messages
                  }
                });
            }
          }.bind(this),
        );
        $iframeContainer.append(iform);
      },
      _promiseSubmitPayment(_$form) {
        return new Promise(function (resolve, reject) {
          const ajaxData = _$form.serializeArray();

          ajaxData.push({
            name: 'action',
            value: 'donation_monthly_submit_payment',
          });

          $.post(guidedogsGlobals.ajaxurl, ajaxData, function (response) {
            if (response && response.status === 'OK') {
              resolve(response);
            } else {
              reject(response);
            }
          }).fail(reject);
        });
      },
    };
  });
});
